"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeEquityLoanPurpose = void 0;
var HomeEquityLoanPurpose;
(function (HomeEquityLoanPurpose) {
    HomeEquityLoanPurpose["BRIDGE"] = "Bridge Loan";
    HomeEquityLoanPurpose["BUSINESS"] = "Business Use";
    HomeEquityLoanPurpose["COMPLETED_IMPROVEMENT"] = "Completed Home Improvement";
    HomeEquityLoanPurpose["CONSOLIDATION"] = "Debt Consolidation";
    HomeEquityLoanPurpose["FUTURE_IMPROVEMENT"] = "Future Home Improvement";
    HomeEquityLoanPurpose["OTHER"] = "Other";
    HomeEquityLoanPurpose["SECONDHOME"] = "Purchase Another Home";
})(HomeEquityLoanPurpose = exports.HomeEquityLoanPurpose || (exports.HomeEquityLoanPurpose = {}));
